var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41",
    transform: "translate(-1367 -840)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 37,
    cy: 35.5,
    rx: 37,
    ry: 35.5,
    transform: "translate(1367 840)",
    fill: "#3542c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email",
    d: "M27.294,1.75a2.95,2.95,0,0,1,2.168.889,2.946,2.946,0,0,1,.888,2.167V23a3.035,3.035,0,0,1-3.056,3.057H3.056A2.95,2.95,0,0,1,.888,25.17,2.946,2.946,0,0,1,0,23V4.806A2.95,2.95,0,0,1,.889,2.638,2.946,2.946,0,0,1,3.056,1.75Zm0,6.113V4.806L15.14,12.412,3.056,4.806V7.862L15.14,15.4Z",
    transform: "translate(1388.349 860.888)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.ff619ba92fb5524fdb425a3e50756cd1.svg";
export { ForwardRef as ReactComponent };